<template>
	<b-card no-body class="m-0">
		<b-card-header header-tag="header" class="p-0" role="tab">
			<b-button block v-b-toggle.accordion-delivery variant="light" class="py-4 accordion-button">DELIVERY</b-button>
		</b-card-header>
		<b-collapse id="accordion-delivery" accordion="services-accordion" role="tabpanel">
			<b-img src="images/tabs/mobile/delivery/delivery.png" alt="delivery" fluid-grow />
			<b-card-body>
				<div class="bg-white p-4" style="border-radius: 20px; top: 30px; right: 30px; border: 2px solid #eee;">
					<b-row>
						<b-col cols="12" class="text-center">
							<div style="font-size: 1.3rem"><b>¿Dónde te lo llevamos?</b></div>
							<div class="mb-4">Cotiza tu envío aquí</div>
							<multiselect class="multiselect-sm" v-model="search" :options="deliverys" :close-on-select="true" :searchable="true" :show-labels="false"  :internal-search="false" placeholder="Envíos" track-by="ComId" @search-change="update_deliver" label="NombreComuna">
								<template slot="noOptions">Escriba la comuna destino.</template>
								<template slot="option" slot-scope="props">
									<span class="option__title">
										{{ props.option.NombreComuna }} <b style="font-size: .7rem;">{{props.option.NombreRegion}}</b>
									</span>
								</template>
								<span slot="noResult">No se encontraron resultados.</span>
							</multiselect>
							<b-button class="p-2 pl-5 pr-5 mt-3" variant="macal" href="javascript:;" @click="quote()"><b>Cotizar</b></b-button>
							<div class="mt-5" style="font-size: 1.2rem">El valor de tu envío</div>
							<div class="text-macal" style="font-size: 4rem; line-height: 4rem">
								<b v-if="show">$ {{this.search.MontoFormat}}</b>
							</div>
							<hr />
							<div>¡Entregamos todos los autos con TAG gratis!</div>
							<div class="mt-2" style="font-size: .8rem">Confirma tu delivery cuando adjudiques</div>
						</b-col>
					</b-row>
				</div>
				<interested :service_type_id="1" :value="this.search ? this.search.Monto : null"></interested>
			</b-card-body>
		</b-collapse>
	</b-card>
</template>

<script>
	import Multiselect from 'vue-multiselect';
	import Interested from '../components/interested';

	export default {
		name: 'v-tab-transfer',
		props: {
			car_id: {default: null},
		},
		components:{
			Multiselect,
			Interested
		},
		data(){
			return {
				search: null,
				deliverys: [],
				show: false
			}
		},
		methods:{
			quote(){
				this.show = true
			},
			update_deliver(query){
				this.axios.get("deliverys",{params: {name: query}}).then(response => {
					this.deliverys = response.data.TarifasComuna
					this.show = false
				})				
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>